/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  SecurityType
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Returns list of security types.
 * @summary Security Types
 */
export const securityTypes = (

 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<SecurityType[]>(
      {url: `/securities/classification/security-types`, method: 'GET', signal
    },
      options);
    }




export const getSecurityTypesQueryKey = () => {
    return [
    `/securities/classification/security-types`
    ] as const;
    }


export const getSecurityTypesQueryOptions = <TData = Awaited<ReturnType<typeof securityTypes>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof securityTypes>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSecurityTypesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof securityTypes>>> = ({ signal }) => securityTypes(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof securityTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type SecurityTypesQueryResult = NonNullable<Awaited<ReturnType<typeof securityTypes>>>
export type SecurityTypesQueryError = unknown


/**
 * @summary Security Types
 */

export function useSecurityTypes<TData = Awaited<ReturnType<typeof securityTypes>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof securityTypes>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSecurityTypesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






